import React from "react";

export default class ChildComponent extends React.Component {

    constructor(props) {
      super(props);
  
      this.child = this.props.child;
      this.index = this.props.index;
      this.ownHousehold = this.props.ownHousehold;
  
      this.state = {
        isDirty: false
      };
  
      this.handleInputChange = this.handleInputChange.bind(this);
      this.handleSaveClick = this.handleSaveClick.bind(this);
      this.handleLabelRemove = this.handleLabelRemove.bind(this);
    }

    removeDuplicates = (arr) => {
      return [...new Set(arr)];
    }

    computeJson() {
      this.child.Name = document.querySelector(`#childName${this.index}`).value;
      // remove duplicate values
      this.child.DislikedFoods = this.removeDuplicates(document.querySelector(`#dislikedFoods${this.index}`).value.split('\n'));
      this.child.FavoriteFoods = this.removeDuplicates(document.querySelector(`#favoriteFoods${this.index}`).value.split('\n'));
      this.child.BedtimeRoutine = this.removeDuplicates(document.querySelector(`#bedtimeRoutine${this.index}`).value.split('\n'));
      this.child.Restrictions = this.removeDuplicates(document.querySelector(`#restrictions${this.index}`).value.split('\n'));
      return JSON.stringify(this.child)
    }

    componentDidMount() {
      const inputs = document.querySelectorAll(`#childName${this.index}, #favoriteFoods${this.index}, #dislikedFoods${this.index}, #bedtimeRoutine${this.index}`);
  
      inputs.forEach((input) => {
        input.addEventListener('input', this.handleInputChange);
      });
    }
  
    componentWillUnmount() {
      const inputs = document.querySelectorAll(`#childName${this.index}, #favoriteFoods${this.index}, #dislikedFoods${this.index}, #bedtimeRoutine${this.index}`);
  
      inputs.forEach((input) => {
        input.removeEventListener('input', this.handleInputChange);
      });
    }
  
    handleInputChange() {
      this.setState({ isDirty: true });
    }
  
    handleLabelRemove(labelType, labelValue) {
      this.setState(prevState => ({
        [labelType]: prevState[labelType].filter(item => item !== labelValue),
        isDirty: true,
      }));
    }

    handleSaveClick() {

      const requestBody = this.computeJson();
      fetch(`${process.env.REACT_APP_API_BASE_URL}/updateChild`, {
        method: 'POST',
        credentials: 'include',
        body: requestBody
      })
        .then(response => {
          if (response.status === 200) {
            this.setState({ isDirty: false });
          } else {
            // Handle non-200 status codes, if necessary
            alert("Failed to save. Try again later.")            
          }
        })
        .catch(error => {
          // Handle fetch errors, if necessary
          console.error('Error fetching data:', error);
        });      
    }

  
    render() {      
      const { ownHousehold, child } = this.props;
    
      if (!ownHousehold) {
        return (
          <>      
            <p><strong>Name:</strong> {child.Name}</p>
            <p><strong>Favorite Foods:</strong> {child.FavoriteFoods.join(', ')}</p>
            <p><strong>Disliked Foods:</strong> {child.DislikedFoods.join(', ')}</p>
            <p><strong>Restrictions:</strong> {child.Restrictions.join(', ')}</p>        
            <p><strong>Bedtime Routine:</strong> {child.BedtimeRoutine ? child.BedtimeRoutine.join(', ') : ''}</p>
          </>
        );
      }
    
      return (
        <>      
          <p><strong>Name:</strong></p>
          <p><input id={ "childName" + this.index } type="text" defaultValue={child.Name} /></p>
          <p><strong>Favorite Foods:</strong></p>
          <p><textarea id={ "favoriteFoods" + this.index } defaultValue={child.FavoriteFoods.join('\n')} /></p>
          <p><strong>Disliked Foods:</strong></p>
          <p><textarea id={ "dislikedFoods" + this.index } defaultValue={child.DislikedFoods.join('\n')} /></p>
          <p><strong>Restrictions:</strong></p>
          <p><textarea id={ "restrictions" + this.index } defaultValue={child.Restrictions.join('\n')} /></p>        
          <p><strong>Bedtime Routine:</strong></p>
          <p><textarea id={ "bedtimeRoutine" + this.index } defaultValue={child.BedtimeRoutine ? child.BedtimeRoutine.join('\n') : ''} /></p>
          {ownHousehold && <button onClick={this.handleSaveClick} id={"saveChildButton" + this.index} disabled={!this.state.isDirty}>Save</button>}
        </>
      );
    }
  }